module.exports = configs;